import React from 'react';

import { searchUsers } from 'modules/users';
import { saveZones } from 'helpers/zonesHelpers';
import render from './render';

export class Form extends React.Component {
  static defaultProps = {
    render,
  };

  state = {};

  componentDidMount () {
    this.loadUser();
  }

  componentWillUnmount () {
    this.isCancelled = true;
  }

  unselectUser = () => this.setState({ user: null });

  selectUser = newUser => this.setState({ newUser });

  save = async () => {
    const { zone } = this.props;
    const { newUser: { uuid: CCOD_PST } } = this.state;
    zone.properties.CCOD_PST = CCOD_PST;
    this.setState({ saving: true });
    await saveZones(zone);

    if (this.isCancelled) return;
    this.setState({ saving: false });
    this.loadUser();
  }

  async loadUser () {
    const { zone: { properties: { CCOD_PST } } } = this.props;
    const [user] = await searchUsers({
      uuid: CCOD_PST,
    });

    if (this.isCancelled) return;

    this.setState({ user });
  }

  render () {
    const { render: Render, ...nextProps } = this.props;
    const { user, newUser, saving } = this.state;
    const { unselectUser, selectUser, save } = this;
    const props = {
      ...nextProps,
      user,
      newUser,
      unselectUser,
      selectUser,
      save,
      saving,
    };

    return <Render {...props} />;
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/ZoneEdit/Form/index.js